export const PROFILE = 'PROFILE/get_profile';
export const PROFILE_UPLOAD_ORG_PHOTO = 'PROFILE/upload_org_photo';
